import SenderFooter from '@/pages/sender/components/sender-footer';
import { cn } from '@/lib/utils';
import type { ReactNode, RefObject } from 'react';

export const SENDER_ADMIN_DISABLED = 'Раздел отключил администратор';

interface SenderScreenProps {
	title?: string;
	lead?: ReactNode;
	children?: ReactNode;
	footer?: ReactNode;
	className?: string;
	scrollRef?: RefObject<HTMLDivElement | null>;
}

/** One scroll region. The shell does not add another PageScroll. */
export function SenderScreen({ title, lead, children, footer, className, scrollRef }: SenderScreenProps) {
	return (
		<div className={cn('flex h-full min-h-0 flex-col', className)}>
			<div
				ref={scrollRef}
				data-scroll-container
				className='min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain touch-scroll scrollbar-hide'
			>
				<div className='flex flex-col gap-4 px-3 py-3'>
					{title ? <h1 className='text-[17px] font-medium leading-6'>{title}</h1> : null}
					{lead}
					{children}
				</div>
			</div>
			{footer ? <SenderFooter>{footer}</SenderFooter> : null}
		</div>
	);
}

export function senderPrimaryButtonClassName() {
	return 'min-h-11 h-11 w-full text-[15px]';
}
